export default "__VITE_ASSET__DA38v6Up__"